import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['approachTab', 'approachConditions', 'conditionTab', 'approachCondition']
  static values = {
    approachIndex: Number,
    conditionIndex: Number,
  }

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    this.approachIndex = 0
    this.updateApproachActiveClass()
    this.conditionIndex = 0
    this.updateConditonActiveClass()
  }

  selectApproarchTab (event) {
    this.approachIndex = parseInt(event.currentTarget.dataset.approachIndex)
    this.updateApproachActiveClass()
  }

  selectConditionTab (event) {
    this.conditionIndex = parseInt(event.currentTarget.dataset.conditionIndex)
    this.updateConditonActiveClass()
  }

  updateApproachActiveClass () {
    this.approachTabTargets.forEach((element, i) => {
      element.classList.toggle(`${this.className}::approach-active`, i === this.approachIndex)
    })

    this.approachConditionsTargets.forEach((element, i) => {
      element.style.display = i === this.approachIndex ? 'block' : 'none'
    })

    this.conditionIndex = 0
    this.updateConditonActiveClass()
  }

  updateConditonActiveClass () {
    const targetConditions = this.conditionTabTargets.filter((element) => parseInt(element.dataset.parentApproachIndex) === this.approachIndex)
    targetConditions.forEach((element, i) => {
      element.classList.toggle(`${this.className}::condition-tab-active`, i === this.conditionIndex)
    })

    this.approachConditionTargets.forEach((e) => { e.style.display = 'none' })
    const targetApproachCondition = this.approachConditionTargets.filter((element) => parseInt(element.dataset.parentApproachIndex) === this.approachIndex)
    targetApproachCondition.forEach((element, i) => {
      if (i === this.conditionIndex) {
        element.style.display = 'block'
      }
    })
  }
}
